import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import Routes from './Routes'

const mapStateToProps = (state) => {
  return {
    hasData: state.temp.hasData,
    isServerLive: state.temp.isServerLive
  }
}

const RoutesContainer = withRouter(connect(
  mapStateToProps,
  null
)(Routes))

export default RoutesContainer
